export const sizesPx = {
    '8': 8,
    '12': 12,
    '14': 14,
    '16': 16,
    '18': 18,
    '20': 20,
    '25': 25,
    '36': 36,
    '40': 40,
    '38': 38,
    '42': 42,
    '50': 50,
    '54': 54,
    '60': 60,
    '66': 66,
    '70': 70,
    '140': 140,
    '144': 144,
    '240': 240,
} as const;

export const sizes = Object.keys(sizesPx) as Array<keyof typeof sizesPx>;

export type Size = (typeof sizes)[number];
